var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "a",
      {
        staticClass: "info-card info-card--full-height",
        attrs: { href: _vm.item.Url }
      },
      [
        _c("div", { staticClass: "info-card__image-frame" }, [
          _vm.item.Image
            ? _c(
                "picture",
                {
                  staticClass:
                    "c-image-frame c-image-frame--border-radius-at-medium",
                  class: _vm.imageModifier
                },
                [
                  _vm.item.Image.Crops["1:1 Aspect Ratio Crop"]
                    ? _c("source", {
                        attrs: {
                          width: "1200",
                          height: "1200",
                          "data-srcset":
                            _vm.item.Image.Crops["1:1 Aspect Ratio Crop"]
                              .SrcSet,
                          media: "(max-width: 959px)"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "c-image-frame__image lazyload",
                    attrs: {
                      width: "1200",
                      height: "750",
                      "data-sizes": "auto",
                      alt: "",
                      "data-srcset":
                        _vm.item.Image.Crops["16:10 Aspect Ratio Crop"].SrcSet,
                      "data-src":
                        _vm.item.Image.Crops["16:10 Aspect Ratio Crop"].Src
                    }
                  })
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "info-card__content", class: _vm.contentModifier },
          [
            _c(
              "div",
              { staticClass: "info-card__heading", class: _vm.headingModifier },
              [
                _c("span", [_vm._v(_vm._s(_vm.item.Name))]),
                _vm._v(" "),
                _vm.showArrows
                  ? _c("span", { staticClass: "info-card__arrow" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "25px",
                            height: "15px",
                            viewBox: "0 0 56 31.617"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M0 15.798a2.25 2.25 0 002.23 2.27h46.19L39 27.738a2.29 2.29 0 000 3.21 2.19 2.19 0 003.15 0l13.21-13.54a2.345 2.345 0 000-3.22L42.15.668a2.19 2.19 0 00-3.15 0 2.29 2.29 0 000 3.21l9.43 9.68H2.23A2.25 2.25 0 000 15.798z"
                            }
                          })
                        ]
                      )
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm.item.Description
              ? _c("div", { staticClass: "info-card__description" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.item.Description) + "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.hideTags
              ? _c(
                  "div",
                  { staticClass: "info-card__tag" },
                  [
                    _vm.intersectedTags
                      ? [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.intersectedTags.slice(0, 3).join(", ")
                              ) +
                              "\n          "
                          ),
                          _vm.intersectedTags.length > 3
                            ? [_vm._v("...")]
                            : _vm._e()
                        ]
                      : _vm.item.PrimaryTag
                      ? [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.item.PrimaryTag.Name) +
                              "\n        "
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }